const doc = [({"ko":({"adminComponentHotelFilter":({"addFilter":"필터 추가", "hotelFilterTitle":"필터 설정"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;